var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurplePlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_3947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 14.6606H14.6608",
    stroke: "#9810FA",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51251 7.17704L1.33301 5.99753L2.66578 2.99879L3.39881 3.3653C3.76532 3.55189 3.99856 3.92507 3.99856 4.33157C3.99856 4.73806 4.23179 5.11124 4.59831 5.29783L5.33133 5.66434L7.3305 1.66602L8.0302 2.0192C8.22466 2.11605 8.39249 2.25897 8.51909 2.43551C8.64569 2.61205 8.72721 2.81686 8.75656 3.03211L9.23636 6.6306C9.26572 6.84585 9.34724 7.05066 9.47384 7.2272C9.60044 7.40374 9.76827 7.54666 9.96273 7.64351L12.8948 9.10956C13.1747 9.25617 13.4146 9.47608 13.5679 9.7493L13.9677 10.4357C14.2942 11.0221 13.9277 11.7551 13.2613 11.8351L12.475 11.935C12.1618 11.975 11.8419 11.9217 11.5621 11.7751L2.85904 7.43027C2.73061 7.36513 2.61358 7.27962 2.51251 7.17704Z",
    stroke: "#9810FA",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_3947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9933,
    height: 15.9933,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePlane);
export default __webpack_public_path__ + "static/media/purple_plane.e2f00f923dadb5433d14fea26fe89321.svg";
export { ForwardRef as ReactComponent };